export const ANIMATION_INITIAL_DELAY = 2000;
export const ANIMATION_DEFAULT_DELAY = 0;
export enum SCREEN_BREAKPOINT_NAMES {
  'small' = 'small',
  'medium' = 'medium',
  'large' = 'large',
}

export const ANIMATION_NAME_REGEX = /^(?!manifest\.json$).*\.json$/gm;
